import React from 'react';

const O_nama = () => {
  return (
    <div style={{ padding: '1rem', maxWidth: '700px', margin: '0 auto' }}>
      <h1>O meni</h1>

      <p>
        <strong>kalkulator-plata.com</strong> je nastao iz moje svakodnevne potrebe za
        brzim i preciznim obračunom plata i doprinosa. Moje ime je Nebojša Pandžić pomoćni sam 
        knjigovođa već duži niz godina u jednoj firmi u Republici Srpskoj. Inače sam zaljubljenik
        u IT i nekako sam se čitavog života usputno bavio tim. Dok sam obračunavao plate, shvatio sam
        da na tržištu nema dovoljno jednostavnih i sveobuhvatnih online alata prilagođenih
        lokalnim propisima – pa sam odlučio da razvijem svoj.
      </p>
      <p style={{ margin: '1rem 0' }}></p>
      <ul>
        <li>
          <strong>Precizne kalkulacije:</strong> Automatizovan obračun bruto/neto plata, doprinosa,
          prekovremenih sati, minulog rada, toplog obroka, drugih dodataka i odbitaka sve prema
          aktuelnim zakonskim propisima BIH.
        </li>
      <p style={{ margin: '1rem 0' }}></p>
        <li>
          <strong>Ušteda vremena:</strong> Sve informacije potrebne za obračun plate na jednom mjestu.
        </li>
      <p style={{ margin: '1rem 0' }}></p>
        <li>
          <strong>Sigurnost podataka:</strong> Kod i formule su skriveni na backendu, a svim
          rezultatima pristupaš samo putem preglednika, bez rizika od neovlašćenog kopiranja.
        </li>
      <p style={{ margin: '1rem 0' }}></p>
        <li>
          <strong>Jednostavan interfejs:</strong> Dizajniran da bude intuitivan, pregledan i
          prilagođen svim veličinama ekrana – desktop, tablet i mobilni.
        </li>
      </ul>
      <p style={{ margin: '1rem 0' }}></p>
      <p>
        Sajt je nastao kao mali lični projekat iz potrebe za ovakvim sveobuhvatnim alatom i idejom da ga 
        konstantno usavršavam.
      <p style={{ margin: '1rem 0' }}></p>
        Ako primetite neku grešku ili imate prijedlog za novu funkcionalnost, slobodno mi se javi putem
        stranice <a href="/kontakt">Kontakt</a>. Vaši feedback-ovi pomažu da alat stalno unapređujem.
      </p>
      <p style={{ margin: '1rem 0' }}></p>
      <p>
        Hvala što koristiš <strong>kalkulator-plata.com</strong>
      </p>
    </div>
  );
};

export default O_nama;
